// Decode settings for html5-qrcode, worked out by instrumenting a debug build
// on a real phone against a printed barcode. Each value below fixes something
// measured, not guessed.

/** Whether this browser can decode barcodes natively (Chrome/WebView, not Safari). */
export function hasNativeDetector() {
  return typeof window !== 'undefined' && 'BarcodeDetector' in window
}

/**
 * `fps` is a flat `setTimeout(1000/fps)` applied *after* each decode, so 10
 * capped the loop near 6 frames a second for no reason.
 *
 * The mirrored retry is wasted work for EAN: zxing's OneDReader already
 * reverses every row and the native detector ignores orientation. Dropping it
 * doubled the frame rate where zxing runs alone. It stays on where the native
 * detector exists, because html5-qrcode alternates engines per decode call and
 * removing the second call halves how often the native one runs.
 *
 * `qrbox` is not just an overlay: the library maps it into source-video
 * coordinates and hands the decoder that region alone. Kept wide so an EAN's
 * quiet zones survive the crop, since clipping them makes it undecodable.
 */
export function buildScannerConfig({ native = hasNativeDetector() } = {}) {
  return {
    fps: 30,
    disableFlip: !native,
    qrbox: (viewfinderWidth, viewfinderHeight) => ({
      width: Math.floor(viewfinderWidth * 0.9),
      height: Math.floor(Math.min(viewfinderHeight * 0.45, viewfinderWidth * 0.45)),
    }),
    videoConstraints: {
      facingMode: 'environment',
      width: { ideal: 1280 },
      height: { ideal: 720 },
    },
  }
}
